import { IApiResponse } from '@interfaces';

import { IApiErrorParams } from './types';

export class ApiError {

	status: number;
	statusText: string;
	message: string;
	code: string;
	serverError: {
		error: string;
		errorDescription: string;
		errorUri: string;
	};
	request: {
		method: string;
		url: string;
		data: string;
	};
	response: IApiResponse<unknown>;

	constructor(params: IApiErrorParams) {
		const {
			status,
			statusText,
			message,
			code,
			serverError,
			request,
			response,
		} = params;

		this.status = status;
		this.statusText = statusText;
		this.message = message;
		this.code = code;
		this.request = request;
		this.response = response;

		if (serverError) {
			this.serverError = {
				error: serverError?.error,
				errorDescription: serverError?.error_description,
				errorUri: serverError?.error_uri,
			};
		} else if (this.response) {
			this.serverError = this.response.data as typeof this.serverError;
		}
	}

}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isApiError(err: any): err is ApiError {
	return typeof err === 'object' && ('statusText' in err) && ('code' in err);
}
